/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_01_AltInputs */

const en_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neon lights in a city at night`)
};

const ar_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أضواء نيون في مدينة ليلية`)
};

const bn_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রাতে শহরে নিয়ন আলো`)
};

const de_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neonlichter bei Nacht`)
};

const es_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luces de neón en una ciudad de noche`)
};

const fr_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lumières néon dans une ville la nuit`)
};

const pt_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luzes de néon em uma cidade à noite`)
};

const zh_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夜晚城市的霓虹灯`)
};

const tr_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geceleri bir şehirde neon ışıkları`)
};

const ru_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неоновые огни в ночном городе`)
};

const pl_elastic_gallery_item_01_alt = /** @type {(inputs: Elastic_Gallery_Item_01_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neony w mieście nocą`)
};

/**
* | output |
* | --- |
* | "Neon lights in a city at night" |
*
* @param {Elastic_Gallery_Item_01_AltInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_01_alt = /** @type {((inputs?: Elastic_Gallery_Item_01_AltInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_01_AltInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_01_alt(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_01_alt(inputs)
	if (locale === "de") return de_elastic_gallery_item_01_alt(inputs)
	if (locale === "es") return es_elastic_gallery_item_01_alt(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_01_alt(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_01_alt(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_01_alt(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_01_alt(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_01_alt(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_01_alt(inputs)
	return en_elastic_gallery_item_01_alt(inputs)
});